import React, { useContext, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import ProductSidebar from "./ProductSidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import Loader from "../../Component/Loader";
import { MyContext } from "../../hooks/useContextProvider";
import Login from "../Authentication/Login";
import Pagination from "../../Component/Pagination";

const ProductList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location: ", location);
  const { token, callCartDetails, cartList, callWishListApi, wishList } =
    useContext(MyContext);
  console.log("wishList: ", wishList);
  console.log("cartList: ", cartList);
  const [loading, setLoading] = useState(false);
  const [allProduct, setAllProduct] = useState([]);
  const [loginModal, setLoginModal] = useState(false);
  const [query, setQuery] = useState({
    mainCategoryId: "",
    categoryId: "",
    subCategoryId: "",
    sortingType: "default",
    minPrice: "0",
    maxPrice: "",
    productName: "",
    minRating: "",
    maxRating: "",
  });
  const [currentPage, setCurrentPage] = useState(1); // page number
  const [totalPages, setTotalPages] = useState(0);
  const limit = 21;

  const getAllProductDetails = async (query, page) => {
    setLoading(true);

    const offset = (page - 1) * limit; // ✅ FIXED

    let formData = new FormData();

    if (query?.mainCategoryId) {
      formData.append("mainCategoryId", query.mainCategoryId);
    }
    if (query?.categoryId) {
      formData.append("categoryId", query.categoryId);
    }
    if (query?.subCategoryId) {
      formData.append("subCategoryId", query.subCategoryId);
    }
    if (query?.sortingType) {
      formData.append("sortingType", query.sortingType);
    }
    if (query?.minPrice !== "") {
      formData.append("minPrice", Number(query.minPrice));
    }
    if (query?.maxPrice) {
      formData.append("maxPrice", Number(query.maxPrice));
    }
    if (query?.productName) {
      formData.append("productName", query.productName);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}productsbycategories?clientId=${
          process.env.REACT_APP_Client_Id
        }&ipAddress=${localStorage.getItem(
          "ipaddress"
        )}&limit=${limit}&offset=${offset}`,
        {
          method: "POST",
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (data?.status) {
        setAllProduct(data.productList || []);

        const totalCount = data?.paginationDetails?.count || 0;
        setTotalPages(Math.ceil(totalCount / limit));
      }
    } catch (error) {
      toast.error("There was an error, Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location?.state) {
      console.log(
        "1111111111111111111111 location?.state?.mainCategory: ",
        location?.state?.mainCategory
      );
      setQuery({ ...query, mainCategoryId: location?.state?.mainCategory?.id });
      setCurrentPage(1);
      // getAllProductDetails({
      //   mainCategoryId: location?.state?.mainCategory?.id,
      //   categoryId: "",
      //   subCategoryId: "",
      //   sortingType: "default",
      //   minPrice: "",
      //   maxPrice: "",
      //   productName: "",
      //   minRating: "",
      //   maxRating: "",
      // }, currentPage);
    }
  }, [location?.state]);

  useEffect(() => {
    setCurrentPage(1);
  }, [query]);

  useEffect(() => {
    getAllProductDetails(query, currentPage);
  }, [query, currentPage]);

  const handleCartBtn = (productDetails) => {
    if (!token) {
      setLoginModal(true);
    } else {
      const selectedVariant = productDetails?.variants.reduce((min, variant) =>
        parseInt(variant.price) < parseInt(min.price) ? variant : min
      );

      setLoading(true);

      let userInfo = JSON.parse(localStorage.getItem("userDetails"));
      let ipAddress = localStorage.getItem("ipaddress");
      let formData = new FormData();

      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("productId", productDetails?.id);
      formData.append(
        "productAttributeId",
        selectedVariant?.attributeDetails?.id
      );
      formData.append("productVariantId", selectedVariant?.id);
      formData.append("qty", 1);
      formData.append("created_by", "");
      formData.append("updated_by", "");
      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addcart?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" ||
              data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setLoading(false);
            callCartDetails();
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setTimeout(() => {
            toast.error("There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };
  const handleWhishListBtn = (productDetails) => {
    if (!token) {
      setLoginModal(true);
    } else {
      setLoading(true);

      let userInfo = JSON.parse(localStorage.getItem("userDetails"));
      let ipAddress = localStorage.getItem("ipaddress");
      let formData = new FormData();

      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("productId", productDetails?.id);
      formData.append("created_by", "");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addwishlist?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" ||
              data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setLoading(false);
            callWishListApi();
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setTimeout(() => {
            toast.error("There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <Breadcrumb
        title={"Shop"}
        mainTitle={"Shop"}
        subTitle={"Home"}
        link={"/"}
      />

      <div id="main">
        <div class="container ProductListContainer">
          {/* Sidebar */}
          <div className="ProductSidebar">
            <ProductSidebar setQuery={setQuery} query={query} />
          </div>
          {/* Main Section Header */}
          <section id="primary" class="page-with-sidebar with-left-sidebar">
            <header class="woocommerce-products-header"></header>
            <div class="woocommerce-notices-wrapper"></div>
            <div
              class="product-loop-sorting"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              {/* <div
                class="product-loop-sorting-item"
                style={{ width: "max-content" }}
              >
                <p class="woocommerce-result-count">
                  Showing {offset}&ndash;{limit} of {totalCount} results
                </p>
              </div> */}
              <div
                class="product-loop-sorting-item"
                style={{ width: "max-content", background: "#f9f9f9" }}
              >
                <form class="woocommerce-ordering" method="get">
                  <select
                    name="orderby"
                    class="orderby px-2"
                    aria-label="Shop order"
                    onChange={(e) => {
                      setQuery({ ...query, sortingType: e.target.value });
                    }}
                    value={query.sortingType ? query.sortingType : "default"}
                  >
                    <option value="default">Default sorting</option>
                    <option value="mostpopular">Most Popular</option>
                    <option value="mostrated">Most Rated</option>
                    <option value="date">Date</option>
                  </select>
                  <input type="hidden" name="paged" value="1" />
                </form>
              </div>
            </div>

            <div class="wdt-tabs-content-wrapper" style={{ marginTop: 20 }}>
              <div id="wdt-tabs-0" class="wdt-tabs-content">
                <div
                  data-elementor-type="page"
                  data-elementor-id="573"
                  class="elementor elementor-573"
                >
                  <section
                    class="elementor-section elementor-top-section elementor-element elementor-element-4dd089d elementor-section-full_width elementor-section-height-default elementor-section-height-default "
                    data-id="4dd089d"
                    data-element_type="section"
                  >
                    <div class="elementor-container elementor-column-gap-no">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6d491aa"
                        data-id="6d491aa"
                        data-element_type="column"
                      >
                        <div class="elementor-widget-wrap elementor-element-populated">
                          <div
                            class="elementor-element elementor-element-a793e17 elementor-widget elementor-widget-wdt-shop-products"
                            data-id="a793e17"
                            data-element_type="widget"
                          >
                            <div class="elementor-widget-container">
                              <div class="wdt-products-container woocommerce wdt-products-carousel-a793e17">
                                <ul class="products product-style-default product-hover-secimage-fade product-content-hover-slidebottom product-without-space product-padding-content wdt-cus-product-style-01 true product-label-boxed false product-thumb-alignment-bottom product-thumb-iconsgroup-position-horizontal horizontal-position-top-right product-thumb-iconsgroup-style-skinbrdrfill-rounded product-thumb-buttonelement-style-bgfill-square product-thumb-buttonelement-stretch product-content-alignment-center product-content-iconsgroup-style-simple product-content-buttonelement-style-simple column-3">
                                  <li class="product isotope-grid-sizer">
                                    <div class="wdt-col wdt-col-xs-12 wdt-col-sm-12 wdt-col-md-6 wdt-col-qxlg-4 wdt-col-hxlg-4 wdt-col-lg-4"></div>
                                  </li>
                                  {allProduct?.map((item, i) => {
                                    let dashedPrice =
                                      item?.variants?.length > 0 &&
                                      item?.variants.reduce((min, variant) =>
                                        parseInt(variant.price) <
                                        parseInt(min.price)
                                          ? variant
                                          : min
                                      )?.price;
                                    let originalPrice = "";
                                    if (item?.discountedPercentage) {
                                      originalPrice = parseFloat(
                                        parseFloat(dashedPrice) -
                                          (dashedPrice *
                                            item?.discountedPercentage) /
                                            100
                                      ).toFixed(2);
                                    } else {
                                      originalPrice = dashedPrice;
                                    }

                                    return (
                                      <li
                                        key={i}
                                        class="blog-entry format-standard product-grid-view product type-product post-1631 status-publish first instock product_cat-wooden-chair product_tag-chair has-post-thumbnail sale shipping-taxable purchasable product-type-simple"
                                      >
                                        <div class="wdt-col wdt-col-xs-12 wdt-col-sm-12 wdt-col-md-6 wdt-col-qxlg-4 wdt-col-hxlg-4 wdt-col-lg-4">
                                          <div class="product-wrapper">
                                            <div class="product-thumb">
                                              <Link
                                                to={`/product-details/${item?.id}`}
                                                class="image"
                                                title="Solid Wood Chair"
                                              >
                                                <div class="product-thumb-overlay"></div>
                                                {item?.label && (
                                                  <div class="product-labels">
                                                    <span class="new">
                                                      <span>{item?.label}</span>
                                                    </span>
                                                  </div>
                                                )}
                                                <div class="primary-image">
                                                  <img
                                                    decoding="async"
                                                    src={
                                                      JSON.parse(
                                                        item?.productGallery ||
                                                          "[]"
                                                      )?.[0]
                                                    }
                                                    alt="Shop Primary Image"
                                                    title="Shop Primary Image"
                                                  />
                                                </div>
                                              </Link>
                                              <div class="product-thumb-content">
                                                <div class="product-buttons-wrapper product-button">
                                                  <div class="wc_inline_buttons">
                                                    <div
                                                      class="wcct_btn_wrapper wc_btn_inline"
                                                      data-tooltip="Add To Cart"
                                                    >
                                                      <Link
                                                        onClick={() => {
                                                          handleCartBtn(item);
                                                        }}
                                                        class="wdt-button too-small button product_type_simple add_to_cart_button ajax_add_to_cart"
                                                      >
                                                        Add to cart
                                                      </Link>
                                                      <span
                                                        id="woocommerce_loop_add_to_cart_link_describedby_1631"
                                                        class="wdt-button too-small screen-reader-text"
                                                      ></span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="product-element-group-wrapper">
                                                  <div class="product-element-group-items">
                                                    <div class="product-buttons-wrapper product-icons">
                                                      <div class="wc_inline_buttons">
                                                        <div
                                                          class="wcct_btn_wrapper wc_btn_inline"
                                                          data-tooltip="Add To Cart"
                                                        >
                                                          <Link
                                                            onClick={() => {
                                                              handleCartBtn(
                                                                item
                                                              );
                                                            }}
                                                            class="wdt-button too-small button product_type_simple add_to_cart_button ajax_add_to_cart"
                                                          >
                                                            Add to cart
                                                          </Link>
                                                          <span
                                                            id="woocommerce_loop_add_to_cart_link_describedby_1631"
                                                            class="wdt-button too-small screen-reader-text"
                                                          ></span>
                                                        </div>
                                                        <div
                                                          class="wcwl_btn_wrapper wc_btn_inline"
                                                          data-tooltip="Wishlist"
                                                        >
                                                          <div
                                                            class="tinv-wraper woocommerce tinv-wishlist tinvwl-shortcode-add-to-cart tinvwl-furniforma_woo_loop_product_button_elements_wishlist"
                                                            data-tinvwl_product_id="1631"
                                                          >
                                                            <div class="tinv-wishlist-clear"></div>
                                                            {wishList?.find(
                                                              (er) =>
                                                                er
                                                                  ?.productDetails
                                                                  ?.id ===
                                                                item?.id
                                                            ) ? (
                                                              <Link
                                                                to="/wishlist"
                                                                role="button"
                                                                class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after  inited-add-wishlist tinvwl-product-in-list"
                                                                tabindex="0"
                                                              >
                                                                <span class="tinvwl_add_to_wishlist-text">
                                                                  Go to Wishlist
                                                                </span>
                                                              </Link>
                                                            ) : (
                                                              <Link
                                                                onClick={() => {
                                                                  handleWhishListBtn(
                                                                    item
                                                                  );
                                                                }}
                                                                role="button"
                                                                class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after"
                                                                tabindex="0"
                                                              >
                                                                <span class="tinvwl_add_to_wishlist-text">
                                                                  Add to
                                                                  Wishlist
                                                                </span>
                                                              </Link>
                                                            )}
                                                            <div class="tinv-wishlist-clear"></div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="product-details">
                                              <div class="product-title">
                                                <h5>
                                                  <Link
                                                    to={`/product-details/${item?.id}`}
                                                  >
                                                    {item?.productName}
                                                  </Link>
                                                </h5>
                                              </div>
                                              <div class="product-price">
                                                <span class="price">
                                                  <span
                                                    class="woocs_price_code"
                                                    data-currency=""
                                                    data-redraw-id="67ad7161b1e8e"
                                                    data-product-id="1631"
                                                  >
                                                    {item?.discountedPercentage && (
                                                      <del aria-hidden="true">
                                                        <span class="woocommerce-Price-amount amount">
                                                          <bdi>
                                                            <span class="woocommerce-Price-currencySymbol">
                                                              &#8377;
                                                            </span>
                                                            &nbsp;{dashedPrice}
                                                          </bdi>
                                                        </span>
                                                      </del>
                                                    )}

                                                    <ins aria-hidden="true">
                                                      <span class="woocommerce-Price-amount amount">
                                                        <bdi>
                                                          <span class="woocommerce-Price-currencySymbol">
                                                            &#8377;
                                                          </span>
                                                          &nbsp;
                                                          {originalPrice}
                                                        </bdi>
                                                      </span>
                                                    </ins>
                                                  </span>
                                                </span>
                                              </div>
                                              <div class="product-rating-wrapper">
                                                <div
                                                  class="star-rating"
                                                  role="img"
                                                  aria-label="Rated 4.00 out of 5"
                                                >
                                                  <span
                                                    style={{
                                                      width: `${
                                                        (+item
                                                          ?.averageRatingsDetails?.[0]
                                                          ?.averageRating /
                                                          5) *
                                                        100
                                                      }%`,
                                                    }}
                                                  >
                                                    Rated
                                                    <strong class="rating">
                                                      {
                                                        +item
                                                          ?.averageRatingsDetails?.[0]
                                                          ?.averageRating
                                                      }
                                                      .00
                                                    </strong>
                                                    out of 5
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>

          {loginModal && <Login open={loginModal} setOpen={setLoginModal} />}

          {/* Main Section */}
        </div>
        {totalPages > 1 && (
          <div className="custom-pagination-wrapper">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                setCurrentPage(page);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ProductList;
